import { useQuery } from '@tanstack/react-query';
import { ContactTag } from '../../types/ContactTag';
import { requestUserTags } from '../userTags/userTags';

export function useUserTags() {
    return useQuery<ContactTag[]>({
        queryKey: ['userTags'],
        queryFn: async ({ signal }) => {
            return (await requestUserTags(signal)).data;
        },
    });
}
